let versionData = {
	"list":[
		{
			"version":"1.0.00",
			"time":"20200324",
			"versionCode":"1.0.14",
			"desc":"H5模板一期兼容各个省份可配置专题"
		}
	]
}

export default versionData;



// WEBPACK FOOTER //
// ./src/config/version.js